<template>

<div class="card">
    <div class="card-body">

      <div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>

      <div v-else-if="cards.length == 0" class="text-center">
        <a href="#/" @click="showModalNewCard('New')" class="btn btn-success px-3">Add Card</a>
      </div>

        <div v-else>

          <!-- Desktop -->
          <table class="datatables-basic table d-none d-md-table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="25%">Card</th>
                  <th class="pl-3" width="25%">Expiry</th>
                  <th class="pl-3" width="25%">Last 4</th>
                  <th class="first-right pl-3" width="25%">Action</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(card, index) in cards" :key="index.id">
              <td class="pl-3">{{card.brand}}</td>
              <td class="pl-3">{{`${card.exp_month} / ${card.exp_year}`}}</td>
              <td class="pl-3">{{card.last4}}</td>
              <td class="pl-3">
                <a href="#/" @click="showModalNewCard('Change',card)" title="Change card"><i class="fa-solid fa-pen-to-square mr-4"></i></a>
                <a href="#/" @click="showModalRemoveCard(card)" title="Remove card"><i class="fa-solid fa-ban"></i></a>
                </td>           
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Card • Expiry</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body" v-for="(card, index) in cards" :key="index">
  
        <td class="pl-2 text-center">
            <div><b>{{card.brand}}</b></div>
            <div>{{`${card.exp_month} / ${card.exp_year}`}}</div>
            <div>
              <a href="#/" @click="showModalNewCard('Change',card)" title="Change card"><i class="fa-solid fa-pen-to-square mr-4"></i></a>
              <a href="#/" @click="showModalRemoveCard(card)" title="Remove card"><i class="fa-solid fa-ban"></i></a>
            </div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>

<new-card :card="selectedCard" :title="newCardTitle" @card-updated="getCards" ></new-card>
<remove-card :card="selectedCard" @card-updated="getCards" ref="RemoveCard"></remove-card>

  </div>
  </div>

</template> 

<script>
export default {
  
  data() {
    return {
      cards: [],
      selectedCard: {},
      newCardTitle: 'Add card',
      loading: true,
    };
  },

  created() {
    this.getCards();
  },

  methods: {

    showModalNewCard(title,card = null) {
      this.newCardTitle = title;
      this.selectedCard = card;
      this.$bvModal.show('bv-modal-new-card');
    },

    showModalRemoveCard(card) {
      this.selectedCard = card;
      this.$refs.RemoveCard.clearContent();
      this.$bvModal.show('bv-modal-remove-card');
    },

    getCards() {

      axios.get('/billing/get-cards').
      then((response) => {
        this.cards = response.data;
        this.loading = false;
      });
    },

  },
};
</script>
